/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/
"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchInterpolatedThresholds = exports.matchThresholds = exports.interpolateThresholds = exports.sortGroupByFrameMax = exports.getThresholdFrame = exports.findBestMatchingGroup = exports.flattenVariables = exports.HLAEngineResultGroupThresholdOperator = exports.HLAEngineResultGroupType = void 0;
var HLAEngineVariable_1 = require("./HLAEngineVariable");
var HLAEngineResultGroupType;
(function (HLAEngineResultGroupType) {
    HLAEngineResultGroupType["Punctual"] = "punctual";
    HLAEngineResultGroupType["Binary"] = "binary";
    HLAEngineResultGroupType["Synthesis"] = "synthesis";
    HLAEngineResultGroupType["DSA"] = "dsa";
    HLAEngineResultGroupType["Crossmatch"] = "crossmatch";
})(HLAEngineResultGroupType || (exports.HLAEngineResultGroupType = HLAEngineResultGroupType = {}));
var HLAEngineResultGroupThresholdOperator;
(function (HLAEngineResultGroupThresholdOperator) {
    HLAEngineResultGroupThresholdOperator["GT"] = ">";
    HLAEngineResultGroupThresholdOperator["GTE"] = ">=";
    HLAEngineResultGroupThresholdOperator["LT"] = "<";
    HLAEngineResultGroupThresholdOperator["LTE"] = "<=";
})(HLAEngineResultGroupThresholdOperator || (exports.HLAEngineResultGroupThresholdOperator = HLAEngineResultGroupThresholdOperator = {}));
var thresholdFuncs = (_a = {},
    _a[HLAEngineResultGroupThresholdOperator.GT] = function (v, t) {
        return v > t;
    },
    _a[HLAEngineResultGroupThresholdOperator.GTE] = function (v, t) {
        return v >= t;
    },
    _a[HLAEngineResultGroupThresholdOperator.LT] = function (v, t) {
        return v < t;
    },
    _a[HLAEngineResultGroupThresholdOperator.LTE] = function (v, t) {
        return v <= t;
    },
    _a);
function flattenVariables(variables) {
    var types = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        types[_i - 1] = arguments[_i];
    }
    var flatten = {};
    variables.forEach(function (v) {
        if (types.length > 0 && types.indexOf(v.type) === -1)
            return;
        flatten[v.name] = v.value;
    });
    return flatten;
}
exports.flattenVariables = flattenVariables;
// Retourne le groupe de résultat le plus spécifiquement proche de la valeur données
// i.e. qui encadre de manière la plus précise celle ci.
function findBestMatchingGroup(groups, variables, value) {
    var flattened = flattenVariables(variables, HLAEngineVariable_1.HLAEngineVariableType.Number);
    var matches = groups.filter(function (group) { return matchThresholds(group.thresholds, flattened, value); });
    // On recherche le groupe le plus spécifique i.e.
    // celui avec les plus de seuils définis
    matches.sort(function (g1, g2) {
        var i1 = interpolateThresholds(g1.thresholds, flattened);
        var i2 = interpolateThresholds(g2.thresholds, flattened);
        var f1 = getThresholdFrame(i1);
        var f2 = getThresholdFrame(i2);
        var r1 = f1[1] - f1[0];
        var r2 = f2[1] - f2[0];
        if (r1 > r2)
            return 1;
        if (r1 < r2)
            return -1;
        return 0;
    });
    return matches[0];
}
exports.findBestMatchingGroup = findBestMatchingGroup;
function getThresholdFrame(thresholds) {
    var min = thresholds[HLAEngineResultGroupThresholdOperator.GT] || thresholds[HLAEngineResultGroupThresholdOperator.GTE] || Number.MIN_SAFE_INTEGER;
    var max = thresholds[HLAEngineResultGroupThresholdOperator.LT] || thresholds[HLAEngineResultGroupThresholdOperator.LTE] || Number.MAX_SAFE_INTEGER;
    return [min, max];
}
exports.getThresholdFrame = getThresholdFrame;
function sortGroupByFrameMax(t1, t2) {
    var _a = getThresholdFrame(t1), min1 = _a[0], max1 = _a[1];
    var _b = getThresholdFrame(t2), min2 = _b[0], max2 = _b[1];
    // First compare by minimum (the lower bound determines the "level")
    // OK < ZG < NOK because OK has min=MIN, ZG has min=MIN, NOK has min=1000
    if (min1 > min2)
        return 1;
    if (min1 < min2)
        return -1;
    // If minimums are equal, compare by maximum as secondary criteria
    if (max1 > max2)
        return 1;
    if (max1 < max2)
        return -1;
    return 0;
}
exports.sortGroupByFrameMax = sortGroupByFrameMax;
function interpolateThresholds(thresholds, vars) {
    var interpolated = {};
    Object.keys(thresholds).forEach(function (op) {
        interpolated[op] = vars[thresholds[op]];
    });
    return interpolated;
}
exports.interpolateThresholds = interpolateThresholds;
function matchThresholds(thresholds, vars, value) {
    var interpolated = interpolateThresholds(thresholds, vars);
    return matchInterpolatedThresholds(interpolated, value);
}
exports.matchThresholds = matchThresholds;
function matchInterpolatedThresholds(thresholds, value) {
    var operators = Object.keys(thresholds);
    if (operators.length === 0)
        return true;
    for (var i = 0; i < operators.length; i++) {
        var op = operators[i];
        if (thresholdFuncs[op] === undefined) {
            throw new Error("Could not find threshold function associated to operator '".concat(op, "' !"));
        }
        var match = thresholdFuncs[op](value, thresholds[op]);
        if (!match)
            return false;
    }
    return true;
}
exports.matchInterpolatedThresholds = matchInterpolatedThresholds;
